module.exports = __webpack_public_path__ + "static/media/35.6f4ef365.avif";